import {
    Modal,
    Card,
    Row,
    Col,
    Input,
    Select,
    Typography,
} from "antd"
import {  UploadTooltipHumanResources } from "../../../../../../shared"

const { TextArea } = Input
const { Title, Text } = Typography
const { Option } = Select

export function ModalHistoryConcept({
    open,
    onCancel,
    dataItem={},
    type
}) {

const contractTypes = {
  "EMPLOYEE": "Empleado",
  "HONORARIES": "Honorarios",
  "SALARY_ASSIMILATION": "Asimilados a salarios",
  "EXTERNAL_CONSULTANT": "Consultor externo"
}
    const bodyCard = (data)=>{
      return (
      <Card
      style={{
        border: `1px solid ${data.color}`,
        margin:"2%"
      }}
      bodyStyle={{ padding: 16 }}
      title={
        <div
          style={{
            background: data.color,
            padding: "6px 12px",
            fontWeight: 600,
          }}>
          {data.titulo}
        </div>
      }
    >
      <Row gutter={[16, 8]}>
        <Col span={12}>
          <strong>{data.typeDate}</strong>
        </Col>
        <Col span={12}>{data.date}</Col>

        <Col span={12}>
          <strong>Nombre:</strong>
        </Col>
        <Col span={12}>{data.name}</Col>

        <Col span={12}>
          <strong>RFC:</strong>
        </Col>
        <Col span={12}>{data.rfc}</Col>
        {data.contratacion && (
        <>
          <Col span={12}>
            <strong>Contratación:</strong>
          </Col>
          <Col span={12}>{contractTypes[data.contratacion] || data.contratacion}</Col>
        </>
      )}
        <Col span={12}>
          <strong>Teléfono:</strong>
        </Col>
        <Col span={12}>{data.phone}</Col>

        {data.contactName && (
        <>
          <Col span={12}>
            <strong>Contacto responsable:</strong>
          </Col>
          <Col span={12}>{contractTypes[data.contactName] || data.contactName}</Col>
        </>
      )}
        <Col span={12}>
          <strong>Comentarios del administrador:</strong>
        </Col>
        <Col span={12}>{data.comentarios}</Col>
        <Col span={12}>
          <strong>Email:</strong>
        </Col>
        <Col span={12}>{data.email || data.commercialAddress}</Col>
        {data.prestaciones && (
        <>
        <Col span={12}>
          <strong>Prestaciones:</strong>
        </Col>
        <Col span={12}>{data.prestaciones}</Col>
        </>
        )}
        <Col span={18}>
          ¿Se realizó convocatoria pública para la contratación?
        </Col>
        <Col span={6}>{data.convocatoria ? "Sí" : "No"}</Col>
        {data.justification && (
          <>
            <Col span={12}>
            ¿Cuál fue el proceso de contratación y justificación de la contratación?
            </Col>
            <Col span={12}>
              {data.justification}
            </Col>
          </>
        )}
        <Col span={18}>
          ¿Tiene relación de parentesco con el equipo operativo, directivo o con el órgano de gobierno?
        </Col>
        <Col span={6}>{data.gobierno ? "Sí" : "No"}</Col>
        {data.gobierno && (
          <>
            <Col span={12}>
              Relación de parentesco:
            </Col>
            <Col span={12}>
              {data.relationshipDetail}
            </Col>
          </>
        )}
        <Col span={18}>
          ¿Pertenece a la administración pública, como empleado o como prestador de servicio?
        </Col>
        <Col span={6}>{data.servicios ? "Sí" : "No"}</Col>
        {data.servicios && (
        <>
          <Col span={12}>
           Favor de poner el cargo:
          </Col>
          <Col span={12}>{data.position_administration}</Col>
          <Col span={12}>
            ¿Bajo qué tipo de contratación?
          </Col>
          <Col span={12}>
            {contractTypes[data.contractType_administration] || data.contractType_administration}
          </Col>
          <Col span={12}>
            ¿Cuántas horas dedica al puesto?
          </Col>
          <Col span={12}>{data.hours_administration}</Col>
        </>
      )}
        <Col span={24} style={{ marginTop: 10 }}>
          <strong>Anexos</strong>
        </Col>

        <Col span={24}>
          <UploadTooltipHumanResources
            documents={data.documents || []}
            readOnly={true}
            title=""
            small
            maxFile={0}
            />
        </Col>
      </Row>
    </Card>
        )
    }

    return (
        <Modal
            open={open}
            title={"Cambios en recurso humano"}
            onCancel={onCancel}
            onOk={()=>{}}
            okButtonProps={{ disabled: true }}
            okText=""
            cancelText="Cerrar"
            width={type === "add" ? 600 : 1200}
            destroyOnClose
            maskClosable={false}
            zIndex={1031}
        >
        <Row>
        {
            type === "change" &&
            <Col span={12}>{bodyCard({color:"#DEDFE7", titulo:"Persona anterior", typeDate: "Fecha de baja", ...dataItem?.item1})}</Col>
        }
        <Col span={type === "change" ? 12 : 24}>{bodyCard({...dataItem?.item2, color:"#DEDFE7", titulo:"Persona nueva", typeDate: "Fecha efectiva:"})}</Col>
        </Row>
            
        </Modal>
    )
}
